import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'

interface StyledProps {
  $isSelected?: boolean
  $isFirstOfType?: boolean
  $isLastOfType?: boolean
  $hasDivider?: boolean
}

const itemStyles = css<StyledProps>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  width: 100%;
  padding: ${({ theme }) => theme.spacing.md}rem;
  background: ${({ $isSelected = false, theme }) =>
    $isSelected ? theme.colors.defaultHover : theme.colors.neutralWhite};
  border-bottom: ${({ $isLastOfType = false, $hasDivider = true }) =>
    $hasDivider && !$isLastOfType ? '2px solid #f6f7f9' : 0};
  color: ${({ theme }) => theme.colors.neutralBlack};
  text-decoration: none !important;
  border-top-left-radius: ${({ $isFirstOfType = false, theme }) =>
    $isFirstOfType ? `${theme.borderRadius.md}rem` : 0};
  border-top-right-radius: ${({ $isFirstOfType = false, theme }) =>
    $isFirstOfType ? `${theme.borderRadius.md}rem` : 0};
  border-bottom-left-radius: ${({ $isLastOfType = false, theme }) =>
    $isLastOfType ? `${theme.borderRadius.md}rem` : 0};
  border-bottom-right-radius: ${({ $isLastOfType = false, theme }) =>
    $isLastOfType ? `${theme.borderRadius.md}rem` : 0};
  font-size: ${({ theme }) => theme.fontSize.md}rem;
  transition: background 0.2s ease, color 0.2s ease;

  &:hover {
    background: ${({ theme }) => theme.colors.defaultHover};
  }

  &:focus-visible {
    outline: none;
    box-shadow: 0 0 0 3px rgba(16, 112, 202, 0.3);
  }
`

export const DateProgressListLink = styled(Link)<StyledProps>`
  ${itemStyles}
`
